import React from "react"

const TableVersionComparisonWrapper = (props) => {
  const { className } = props

  return <div className={`${className} rjs-table-comparison-wrapper`}>{props.children}</div>
}

export default TableVersionComparisonWrapper
